import '../scss/style.scss';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import select from 'dom-select';
import Swiper from 'swiper/dist/js/swiper.min.js';
import * as bodyScrollLock from 'body-scroll-lock';
import SmoothScroll from 'smooth-scroll';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import throttle from 'lodash.throttle';
import debounce from 'lodash.debounce';
import { classy as cl } from './classy.js';
import { videoResize } from "./videoResize";
import { scrollAnimatron } from './scrollAnimatron';

// barba.use(barbaPrefetch);

(function (doc, win) {
  var app = {
    fixerFn: function() {
      var disableBodyScroll = bodyScrollLock.disableBodyScroll,
        enableBodyScroll = bodyScrollLock.enableBodyScroll,
        bodyScrollLockOptions = { reserveScrollBarGap: true },
        fixed = false;
    
      function getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        outer.style.overflow = "scroll";
        var inner = document.createElement("div");
        inner.style.width = "100%";
        inner.style.opacity = 0;
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
      }
    
      this.fix = function() {
        disableBodyScroll(window.openModal, bodyScrollLockOptions);
        setTimeout(function () {
          if (getScrollbarWidth() !== 0) select('.header').style.cssText = 'right: 4px';
        }, 0);
        fixed = true
      };
    
      this.unfix = function() {
        enableBodyScroll(window.openModal, bodyScrollLockOptions);
        setTimeout(function () {
          select('.header').style.cssText = 'right: 0';
        }, 0);
        fixed = false
      };
    
      this.toggle = function() {
        if (fixed) this.unfix();
        else this.fix();
      }
    },
    
    menuFn: function () {
      var burger = select('.burger'),
        header = select('.header'),
        nav = select('.nav'),
        open = false;
      
      if (burger) burger.addEventListener('click', function () {
        cl(burger).toCls('open');
        cl(header).toCls('open');
        cl(nav).toCls('open');
        open = !open;
      });
      
      this.close = function () {
        cl(burger).rmCl('open');
        cl(header).rmCl('open');
        cl(nav).rmCl('open');
        open = false;
        app.fixer.unfix();
      };
      this.open = function () {
        if (!open) {
          cl(burger).addCl('open');
          cl(header).addCl('open');
          cl(nav).addCl('open');
          open = true;
          app.fixer.fix();
        }
      };
      
      this.scroll = function () {
        var st = window.pageYOffset;
  
        if (st > this.lastScrollTop && st > 50) cl(header).addCl('hide');
        else cl(header).rmCl('hide');
  
        this.lastScrollTop = st;
      };
      
      this.resize = function() {
        cl(header).addCl('resize');
      }
    },
    
    activenav: function() {
      var current = window.location.protocol + "//" + window.location.host + "/" + location.pathname.split("/")[1];
      select.all('.header a').forEach(function(nav) {
        if (nav.href == current) cl(nav).addCl('active');
        else cl(nav).rmCl('active');
      });
    },
    
    swipersArr: [],
    swipers: function(location) {
      location = location || doc;
      if (app.swipersArr.length > 0) {
        app.swipersArr.forEach(function (el) {
          el.destroy();
        });
        app.swipersArr = [];
      }
  
      var swipers = select.all('#swiper', location);
      swipers.forEach(function (el) {
        var initSlide = 0;
        var swiper = new Swiper(el, {
          speed: 1000,
          loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 4000
          },
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          },
          on: {
            slideChange: function() {
              initSlide++
              const current = this.slides[this.activeIndex];
              const currentVideo = select('.autoplay', current);
              select.all('video', el).forEach(function(video) {
                video.pause();
              })
              if (initSlide > 1 && currentVideo) {
                currentVideo.play();
                initSlide = true;
              }
            }
          }
        });
        app.swipersArr.push(swiper);
      });
  
      var swipers2 = select.all('.block-gallery', location);
      swipers2.forEach(function (wrap) {
        var el = select('.swiper-container', wrap);
        var initSlide = 0;
        var swiper = new Swiper(el, {
          speed: 1000,
          loop: true,
          navigation: {
            nextEl: select('.swiper-next', wrap),
            prevEl: select('.swiper-prev', wrap),
          },
          on: {
            slideChange: function() {
              initSlide++
              const current = this.slides[this.activeIndex];
              const currentVideo = select('.autoplay', current);
              select.all('video', el).forEach(function(video) {
                video.pause();
              })
              if (initSlide > 1 && currentVideo) {
                currentVideo.play();
                initSlide = true;
              }
            }
          }
        });
        app.swipersArr.push(swiper);
      });
  
      var swipers3 = select.all('.related', location);
      swipers3.forEach(function (wrap) {
        var el = select('.swiper-container', wrap);
        var swiper = new Swiper(el, {
          speed: 1000,
          slidesPerView: 3,
          slidesPerGroup: 3,
          loop: true,
          spaceBetween: 15,
          allowTouchMove: false,
          breakpoints: {
            1279: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            600: {
              slidesPerView: 1,
              slidesPerGroup: 1
            }
          },
          navigation: {
            nextEl: select('.swiper-next', wrap),
            prevEl: select('.swiper-prev', wrap),
          },
          //effect: 'fade'
        });
        app.swipersArr.push(swiper);
      });
    },

    swiperSequence(swiper) {
      const currentSlide = swiper.slides[swiper.activeIndex];
      const currentVideo = select('.autoplay', currentSlide);
      const delay = currentVideo ? currentVideo.duration * 1000 : 3000;
      var canplay = true;
      var setDelay = false;

      if (currentVideo && canplay) {
        currentVideo.play();
        setDelay = setTimeout(function() {
          swiper.slideNext()
        }, delay)
      }

      swiper.navigation.nextEl.addEventListener('click', function() { canplay = false; if (setDelay) clearTimeout(setDelay) });
      swiper.navigation.prevEl.addEventListener('click', function() { canplay = false; if (setDelay) clearTimeout(setDelay) });
      
      swiper.on('slideChange', function() {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const currentVideo = select('.autoplay', currentSlide);
        const delay = currentVideo ? currentVideo.duration * 1000 : 3000;
        if (canplay) {
          setDelay = setTimeout(function() {
            swiper.slideNext()
          }, delay)
        }
      })
    },
    
    smooth(el, update, speed) {
      if (el) {
        var scroll = new SmoothScroll();
        scroll.animateScroll(el, false, {
          offset: 0,
          updateURL: update || false,
          speed: speed || 1000
        });
      }
    },
  
    hashScroll() {
      var hash = location.hash;
      var el = hash.length && select(location.hash) ? select(location.hash) : false;
      if (el) app.smooth(el)
    },
    
    hashLinks() {
      select.all('a[href*="#"]').forEach(function (link) {
        link.addEventListener('click', function (ev) {
          var linkHash = link.href.replace(link.hash,''),
              windowHash = window.location.href.replace(window.location.hash,'');
          if (linkHash === windowHash) {
            ev.preventDefault(); ev.stopPropagation();
            app.smooth(select(link.hash), true);
          }
        })
      })
    },
  
    spoilers: function() {
      function setHeight(click) {
        var content = select('#'+click.dataset.spoiler);
        var height = content && content.children[0] ? content.children[0].getBoundingClientRect().height : false;
        if (height) {
          if (click.dataset.spoilerHeight) click.dataset.spoilerHeight = height;
          else click.setAttribute('data-spoiler-height', height);
        }
      }
      
      function open(click) {
        var content = select('#'+click.dataset.spoiler);
        cl(click).addCl('active');
        if (content && click.dataset.spoilerHeight) {
          cl(content).addCl('active');
          content.style.cssText = 'height: '+click.dataset.spoilerHeight+'px';
        }
      }
  
      function close(click) {
        var content = select('#'+click.dataset.spoiler);
        cl(click).rmCl('active');
        if (content) {
          cl(content).rmCl('active');
          content.style.cssText = 'height: 0';
        }
      }
      
      var spoilerClicks = select.all('.spoiler-click');
      var active = false;
      
      spoilerClicks.forEach(function (spoilerClick) {
        setHeight(spoilerClick);
        if (spoilerClick.classList.contains('active')) open(spoilerClick);
        
        spoilerClick.addEventListener('click', function () {
          // spoilerClicks.forEach(function (otherSpoiler) {
          //   if (spoilerClick !== otherSpoiler) close(otherSpoiler)
          // });
        
          if (spoilerClick.classList.contains('active')) close(spoilerClick);
          else open(spoilerClick);
        })
      });
      
      this.resize = function ( ) {
        spoilerClicks.forEach(function (spoilerClick) {
          setHeight(spoilerClick);
          if (spoilerClick.classList.contains('active')) open(spoilerClick);
        })
      }
    },
    
    vids: function () {
      select.all('.block-video-wrap, .has-thumb').forEach(function(wrap) {
        var thumb = select('.video-thumb', wrap);
        var video = select('video', wrap);
        var play = false;
        if (thumb && video) {
          thumb.addEventListener('click', function() {
            cl(thumb).toCl('hide');
            if (play && !video.paused) {
              video.pause();
              play = false;
            } else {
              video.play();
              play = true;
            }
          });

          video.addEventListener('ended', function() {
            //video.currentTime = 0;
            cl(thumb).rmCl('hide');
          })
        }
      });
    },
  
    grid: function() {
      var section = select('.news-grid-wrap');
      var grid = select('.news-grid');
      var page = 2;
      var canFetch = grid && grid.dataset.page && grid.dataset.page !== 'false';
    
      if (grid) {
        var msnry = new Masonry(grid, {
          itemSelector: '.news-tile',
          columnWidth: '.grid-sizer',
          gutter: '.gutter-sizer',
          percentPosition: true,
          transitionDuration: 0,
          horizontalOrder: true
        })
      }
      
      function fetchPage(pageNo, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', window.location+'/p'+pageNo, true);
        xhr.responseType = 'document';
        xhr.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200 && callback) callback(this.response);
        };
        xhr.send();
      }
      
      this.scroll = debounce(function () {
        if (grid) {
          var gridH = grid.getBoundingClientRect().height;
          var gridPos = grid.getBoundingClientRect().bottom - gridH/3*2;
    
          if (gridPos < window.innerHeight && canFetch) {
            canFetch = false;
            fetchPage(page, function (resp) {
              var newGrid = select('.news-grid', resp);
              var elements = select.all('.news-tile', resp);
              if (newGrid && newGrid.dataset.page && newGrid.dataset.page === 'false') {
                canFetch = false;
                cl(section).rmCl('have-more')
              }
              else canFetch = true;
              elements.forEach(function(el) {
                grid.appendChild(el);
                if (app.scrollCheck) app.scrollCheck.add({
                  el: el,
                  offset: 60,
                  classAdd: 'fade-in-up'
                });
              });
              
              if (elements) {
                msnry.appended(elements);
                if (app.scrollCheck) app.scrollCheck.scroll()
                page++
              }
            })
          }
        }
      }, 300)
    },
  
    serialize: function(form){if(!form||form.nodeName!=="FORM"){return }var i,j,q=[];for(i=form.elements.length-1;i>=0;i=i-1){if(form.elements[i].name===""){continue}switch(form.elements[i].nodeName){case"INPUT":switch(form.elements[i].type){case"text":case"email":case"tel":case"number":case"hidden":case"password":case"button":case"reset":case"submit":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break;case"checkbox":case"radio":if(form.elements[i].checked){q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value))}break;case"file":break}break;case"TEXTAREA":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break;case"SELECT":switch(form.elements[i].type){case"select-one":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break;case"select-multiple":for(j=form.elements[i].options.length-1;j>=0;j=j-1){if(form.elements[i].options[j].selected){q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].options[j].value))}}break}break;case"BUTTON":switch(form.elements[i].type){case"reset":case"submit":case"button":q.push(form.elements[i].name+"="+encodeURIComponent(form.elements[i].value));break}break}}return q.join("&")
    },
  
    postForm: function(data, link) {
      link = link || window.location;
      data = data || '';
    
      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', link, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-Requested-With','XMLHttpRequest');
        xhr.responseType = 'json';
        xhr.onreadystatechange = function() {
          if (this.readyState === 4) resolve(this.response);
        };
        xhr.send(data);
      })
    },
    
    newsletter: function() {
      var form = select('.newsletter-form');
      if (form) form.addEventListener('submit', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var honn = select('.honn', form);
        var button = select('button', form);
        var error = select('.error', form);
        if (error) error.innerHTML = '';
        if (button) {
          cl(button).addCl('loading');
          button.setAttribute('disabled','')
        }
        if (honn.value === '') app.postForm(app.serialize(form)).then(function(resp) {
          if (resp)  {
            if (button) {
              cl(button).rmCl('loading');
              button.removeAttribute('disabled')
            }
            if (resp.success) barba.go('/subscribe');
            else  {
              if (error) error.innerHTML = resp.message
            }
          }
        })
      })
    },

    arrowDownScroll: function() {
      var arrow = select('.arrow-down');

      this.scroll = function() {
        if (arrow) {
          if (window.pageYOffset > 50) cl(arrow).addCl('hidden');
          else cl(arrow).rmCl('hidden');
        }
      }
    },
  
    setExternalLinks() {
      var host = new RegExp('/' + window.location.host + '/');
      var links = select.all('a[href^="http"], a[href^="mailto"]');
      links.filter(el => !el.href.match(host)).forEach(el => {
        el.setAttribute('target', '_blank')
      })
    },
  
    initOnce: function () {
      app.fixer = new app.fixerFn();
      app.menu = new app.menuFn();
    },
    
    init: function () {
      app.swipers();
      app.activenav();
      app.hashScroll();
      app.hashLinks();
      app.newsletter();
      app.vids();
      app.setExternalLinks();
      app.grd = new app.grid();
      app.spo = new app.spoilers();
      app.arrow = new app.arrowDownScroll();
      app.videoResize = new videoResize('.has-cover-video');
      app.scrollCheck = new scrollAnimatron([
        {
          el: '.an1',
          offset: 100,
          classAdd: 'fade-in-up',
        },
        {
          el: '.an2',
          offset: 200,
          classAdd: 'fade-in-up-small',
        },
        {
          el: '.an3',
          offset: 100,
          classAdd: 'fade-in',
        },
        {
          el: '.an4',
          offset: 220,
          classAdd: 'logos',
        },
        {
          el: '.an5',
          offset: 200,
          hidderClass: 'lin',
          classAdd: 'lines',
        },
        {
          el: '.vid-scroll',
          offset: 0,
          callback: function(el) {
            var video = select('.vid-scroll video', el);
            if (video) video.play();
            //console.log(video.closest('.swiper-container'))
          }
        },
        // {
        //   el: '.autoslide',
        //   offset: 0,
        //   callback: function(el) {
        //     app.swipersArr.forEach(function(swiper) {
        //       if (swiper.$el[0] === el) app.swiperSequence(swiper)
        //     })
        //   }
        // }
      ], 300);
    }
  };
  
  doc.addEventListener('DOMContentLoaded', function () {
    const video = select('.swiper-slide video');
    const firstSlide = select('.has-thumb, .project-image, .news-tile .div-image');
    const imgLoad = firstSlide ? imagesLoaded(firstSlide, { background: true }) : false;
    if (video) {
      var curtainTimeout = setTimeout(function() {
        cl('.curtain').rmCl('open');
      }, 5000);
      video.addEventListener('loadedmetadata', function() {
        clearTimeout(curtainTimeout);
        cl('.curtain').rmCl('open');
      });
    } else if (imgLoad) {
      imgLoad.on('always', function() {
        cl('.curtain').rmCl('open');
      }); 
    } else cl('.curtain').rmCl('open');


    require('viewport-units-buggyfill').init();
    app.initOnce();
    app.init();
  
    select.all('.header a').forEach(function(link) {
      link.addEventListener('click', function(ev) {
        if (link.href === window.location.href) {
          ev.preventDefault(); ev.stopPropagation();
          if (app.menu) app.menu.close();
        }
      })
    });
    
    win.addEventListener('scroll', throttle(function () {
      if (app.scrollCheck) app.scrollCheck.scroll();
      if (app.menu) app.menu.scroll();
      if (app.grd) app.grd.scroll();
      if (app.arrow) app.arrow.scroll();
    }, 200));
  
    win.addEventListener('resize', throttle(function () {
      if (app.scrollCheck) app.scrollCheck.scroll();
      if (app.videoResize) app.videoResize.resize();
      if (app.spo) app.spo.resize();
      if (app.menu) app.menu.resize();
      if (app.arrow) app.arrow.scroll();
    }, 300));
  
    win.addEventListener('resize', debounce(function () {
      cl('.header').rmCl('resize')
    }, 500))
    
    barba.init({
      transitions: [
        {
          leave(data) {
            const done = this.async();
           
            cl('.curtain').addCl('open');
            setTimeout(function () {
              if (app.menu) app.menu.close(true);
              done();
            }, 300)
          },
          enter(data) {
            window.scrollTo(0, 0);
            const firstSlide = select('.slide-image', data.next.container);
            const imgLoad = firstSlide ? imagesLoaded(firstSlide, { background: true }) : false;
        
            if (imgLoad) {
              imgLoad.on('always', function() {
                cl('.curtain').rmCl('open');
              }); 
            } else cl('.curtain').rmCl('open');
          },
          afterEnter(data) {
            app.init();
          }
        }
      ]
    })
  })
})(document, window);